module.exports = __webpack_public_path__ + "img/lanscape-2.a63898d2.jpg";